import { selectTreatmentWithConfig } from '@splitsoftware/splitio-redux';
import { createSelector } from 'reselect';
const selectSplitState = (state) => state.split;
export const isSplitIoInitiated = createSelector(selectSplitState, (state) => state.isReady);
export const getTreatmentWithConfig = () => createSelector([
    selectSplitState,
    (_1, splitName) => splitName,
    (_1, _2, defaultValue) => defaultValue,
], (state, splitName, defaultValue) => {
    return selectTreatmentWithConfig(state, splitName, undefined, defaultValue);
});
export const selectSplit = createSelector([selectSplitState, (_, splitName) => splitName], (splitState, splitName) => {
    const { isReady, isTimedout } = splitState || {};
    const treatment = selectTreatmentWithConfig(splitState, splitName, undefined, 
    // @ts-expect-error use null explicitly
    null);
    const config = treatment?.config != null ? JSON.parse(treatment.config) : null;
    return isReady && treatment != null
        ? {
            ready: true,
            treatment: treatment.treatment,
            config,
        }
        : {
            ready: isTimedout,
            treatment: 'control',
            config: null,
        };
}, {
    memoizeOptions: {
        // increase cache size (default = 1) to store more splits in an LRU-Cache
        maxSize: 64,
    },
});
//# sourceMappingURL=selectors.js.map